import React, { useEffect, useState } from "react";
import { serverLink } from "../../resources/url";
import { toast } from "react-toastify";
import axios from "axios";
import { connect } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import logo from "../../images/logo.png";
import {
    formatDateAndTime,
    encryptData,
    formatDate,
    currencyConverter,
    sendEmail,
    projectURL, projectName
} from "../../resources/constants";
import { setApplicationDetails, setLoginDetails } from "../../actions/actions";
import { Modal, Button } from "react-bootstrap";
import Loader from "../common/loader/loader";

function StartApplication(props) {
    const [isLoading, setIsLoading] = useState(true)
    const [applicationData, setApplicationData] = useState([]);
    const [userData] = useState(props.applicationLogin);
    const [showApplicationModal, setShowApplicationModal] = useState(false);
    const [selectedCourse, setSelectedCourse] = useState("");
    const [status, setStatus] = useState("");
    const [appType, setAppType] = useState("");
    const [filteredCourseList, setFilteredCourseList] = useState([]);
    const handleCloseApplicationModal = () => setShowApplicationModal(false);
    const handleShowApplicationModal = () => setShowApplicationModal(true);
    const navigate = useNavigate();
    const [courseData, setCourseData] = useState([])
    const [paymentData, setPaymentData] = useState([])
    const [studentEnrol, setStudentEnrol] = useState([])
    const [minRegistration, setMinRegistration] = useState([])
    const getApplicationRecord = async () => {
        props.setOnApplicationDetails("");
        toast.info("Loading data. Please wait")
        await axios.get(`${serverLink}application/applicant/application/list/${userData.EntryID}`)
            .then((response) => {
                setApplicationData(response.data);

                setIsLoading(false)
            })
            .catch((error) => {
                console.log("NETWORK ERROR", error);
            }).finally(() => {
                setIsLoading(false)
            })

        await axios.get(`${serverLink}academics/eligible/course/list`)
            .then((response) => {
                setCourseData(response.data);
                setIsLoading(false)
            })
        await axios.get(`${serverLink}application/min/registration`)
            .then((response) => {
                setMinRegistration(response.data);
                setIsLoading(false)
            })
        await axios.get(`${serverLink}application/check_enrolled/${userData.EntryID}`)
            .then((response) => {
                setStudentEnrol(response.data);
                setIsLoading(false)
            })
        await axios.get(`${serverLink}application/applicant/payment/history/${userData.EntryID}`)
            .then((response) => {
                setPaymentData(response.data);
                setIsLoading(false)
            })
            .catch((error) => {
                console.log("NETWORK ERROR", error);
            }).finally(() => {
                setIsLoading(false)
            })
    };
    const [data, setData] = useState({
        applicationType: "",
        course: "",
    });
    const onEdit = (e) => {
        if (e.target.id === "course")
            setSelectedCourse(e.target.value);
        else
            setData({
                ...data,
                [e.target.id]: e.target.value,
            });
    };
    const handleCourseChange = (e) => {
        const { name, value } = e.target;
        const isUndergraduate = value === "ug";
        const isPostgraduate = value === "pg";
        const courseDuration = isUndergraduate ? "Years" : isPostgraduate ? "Months" : "Year";
        setStatus(isUndergraduate ? "1" : isPostgraduate ? "2" : "3");
        setAppType(isUndergraduate ? "ug" : isPostgraduate ? "pg" : "fd");
        const filtered = courseData.filter(x => x.DurationType === courseDuration);
        setFilteredCourseList(filtered);
    };
    useEffect(() => {
        if (props.applicationLogin.length === 0)
            navigate("/login");
    }, [props.applicationLogin]);

    useEffect(() => {
        if (props.applicationLogin.length === 0) navigate("/login");
    }, [props.applicationLogin]);

    useEffect(() => {
        getApplicationRecord();
    }, []);
    const onApplyNow = async () => {
        if (!selectedCourse) {
            toast.error("Please select your course");
            return false;
        }
        const course = courseData.filter(x => x.CourseName === selectedCourse)[0]
        const sendData = {
            ApplicantID: userData.EntryID,
            ApplicationType: appType,
            CourseCode: course
            ,
        };
        toast.info("Processing... Please wait");
        await axios
            .post(`${serverLink}application/apply_now`, sendData)
            .then((response) => {
                const message = response.data.message;
                if (message === "success") {
                    toast.success("Course Selected Successful");
                    handleCloseApplicationModal();
                    getApplicationRecord();
                    sendEmail(
                        userData.EmailAddress,
                        `Thank you for your application to the ${projectName}`,
                        "Application for Admission",
                        `${userData.FirstName} ${userData.MiddleName} ${userData.Surname}`,
                        `Thank you for starting an application for admission to study at ${projectName}. <br/>
                     If you do not have all the required information or documents to submit your application at this time, you can always log in back using you email address and password. <br/>
                    `,
                        `Best Regards <br/> Admission Team <br/> <a target="_blank" href=${projectURL}>${projectURL}</a>`
                    );
                } else if (message === "record exist") {
                    toast.error(
                        "You have a pending application awaiting decision for the course you've selected"
                    );
                } else {
                    toast.error(
                        "Something went wrong. Please check your network and try again!"
                    );
                }
            })
            .catch((error) => {
                console.log("NETWORK ERROR", error);
            });
    };
    const handleLogout = () => {
        props.setOnLoginDetails("");
        props.setOnApplicationDetails("");
        navigate("/login");
    };
    return isLoading ? (<Loader />) : (
        props.applicationLogin !== "" && (
            <>
                <Modal
                    show={showApplicationModal}
                    onHide={handleCloseApplicationModal}
                    size="lg"
                >
                    <Modal.Header >
                        <Modal.Title>Start New Application</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="row">
                            <div className="col-md-6">
                                <div className="form-group">
                                    <label className="form-label">Application Type</label>
                                    <select
                                        className="form-control form-control-solid"
                                        name="applicationType"
                                        id="applicationType"
                                        onChange={handleCourseChange}
                                    >
                                        <option value="">Select application type...</option>
                                        <option value="ug">Undergraduate</option>
                                        <option value="pg">Postgraduate</option>
                                        <option value="fd">Foundation</option>
                                    </select>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <label htmlFor="Course" className="form-label">Programme List </label>
                                <select
                                    className="form-control"
                                    name="course"
                                    id="course"
                                    onChange={onEdit}
                                >
                                    <option value="">Select course...</option>
                                    {filteredCourseList.map((item, index) => (
                                        <option key={index} value={item.courseID}>
                                            {item.CourseName}
                                        </option>
                                    ))}
                                </select>
                            </div>
                            <div className='row  col-md-12 mt-5' >
                                <button style={{ float: 'right' }} type='button' disabled={appType === "" || !selectedCourse}
                                    onClick={() => onApplyNow()} className={status === '1' ? 'btn btn-sm btn-info' : status === '2' ? 'btn btn-sm btn-success' : status === '3' ? 'btn btn-sm btn-primary' : "btn btn-sm btn-secondary"} >
                                    {status === '1' ? 'Apply Undergraduate' : status === '2' ? 'Apply Postgraduate' : status === '3' ? 'Apply Foundation' : 'Select Application Type'}
                                </button>
                            </div>
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="danger" onClick={handleCloseApplicationModal}>
                            Close
                        </Button>
                    </Modal.Footer>
                </Modal>
                <div className="">
                    <div className="container">
                        <div className="row">
                            <div className="name text-center mb-3 mt-4">
                                <img alt="Hensard University Logo" src={logo} style={{ height: '150px' }} />
                            </div>
                            <div className="col-lg-2">
                                <div className="">
                                    <h4>Welcome, {userData.FirstName}</h4>
                                </div>
                                <div className="widget-categories">
                                    <ul className="list-unstyled list-style mb-0">
                                        <hr />
                                        <li >
                                            <Link className="d-flex" to={"/application"}>
                                                <span className={'text-dark'}>Dashboard </span>
                                            </Link>
                                        </li>
                                        <hr />
                                        <li >
                                            <Link className="d-flex" onClick={handleLogout} to={""}>
                                                <span className={'text-dark'}>Logout </span>
                                            </Link>
                                        </li>
                                        <hr />
                                    </ul>
                                </div>

                                <div className="widget row pb-4 mb-5 mt-4">
                                    <div className="col-lg-12 col-sm-12">
                                        <button className="btn btn-sm btn-info w-100" style={{ borderRadius: "10px" }} onClick={handleShowApplicationModal}>
                                            Apply Now
                                        </button>
                                    </div>
                                </div>
                            </div>
                            {/*<div className="card shadow-lg border-0 rounded-4 p-4 col-md-9">*/}
                            <div className="col-lg-10">
                                <div className="instructor">
                                    <div className="row align-items-center">
                                        <div className="col-lg-12">
                                            <div className="instructor-content">
                                                <h4 className="mb-3">Applicant Information</h4>
                                                <div className="table-responsive">
                                                    <table className="table border rounded">
                                                        <tbody>
                                                            <tr>
                                                                <th className="bg-light p-2">Full name</th>
                                                                <td className="p-2">{`${userData.FirstName} ${userData.MiddleName} ${userData.Surname}`}</td>
                                                            </tr>
                                                            <tr>
                                                                <th className="bg-light p-2">Email</th>
                                                                <td className="p-2">{userData.EmailAddress}</td>
                                                            </tr>
                                                            <tr>
                                                                <th className="bg-light p-2">Phone</th>
                                                                <td className="p-2">{userData.PhoneNumber}</td>
                                                            </tr>
                                                            <tr>
                                                                <th className="bg-light p-2">Date of Birth</th>
                                                                <td className="p-2">{formatDate(userData.DateOfBirth)}</td>
                                                            </tr>
                                                            <tr>
                                                                <th className="bg-light p-2">Gender</th>
                                                                <td className="p-2">{userData.Gender}</td>
                                                            </tr>
                                                            <tr>
                                                                <th className="bg-light p-2">Address</th>
                                                                <td className="p-2">{userData.Address}</td>
                                                            </tr>
                                                            <tr>
                                                                <th className="bg-light p-2">State</th>
                                                                <td className="p-2">{userData.StateOfOrigin}</td>
                                                            </tr>
                                                            <tr>
                                                                <th className="bg-light p-2">LGA</th>
                                                                <td className="p-2">{userData.LGA}</td>
                                                            </tr>
                                                            <tr>
                                                                <th className="bg-light p-2">Nationality</th>
                                                                <td className="p-2">{userData.Nationality}</td>
                                                            </tr>
                                                            <tr>
                                                                <th className="bg-light p-2">Religion</th>
                                                                <td className="p-2">{userData.Religion}</td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="row  mt-4">
                                    <h4>Application History</h4>
                                    <div className="col-md-12 mt-3 mb-2">
                                        <div className="custom-datatable-filter table table-responsive">
                                            {applicationData.length > 0 ? (

                                                <table className="table table-responsive-md">
                                                    <thead className="thead-light">
                                                        <tr>
                                                            <th>S/N</th>
                                                            <th>Application ID</th>
                                                            <th>Application Type</th>
                                                            <th>Course Name</th>
                                                            <th>Application Date</th>
                                                            <th>Status</th>
                                                            <th>Adm. Letter</th>
                                                            <th>Action</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {applicationData.map((app, index) => {
                                                            let paid = paymentData.filter(x => parseInt(x.StudentID) === parseInt(app.EntryID))
                                                            let isEnrolled = studentEnrol.filter(x => parseInt(x.ApplicationID) === parseInt(app.EntryID))
                                                            let status = "";
                                                            let action = "--";
                                                            let enrol = "--";
                                                            if (app.Status === 0) {
                                                                status = (
                                                                    <span className="badge badge-warning">
                                                                        Not Submitted
                                                                    </span>
                                                                );
                                                                {
                                                                    app.ApplicationType === 'ug' || app.ApplicationType === 'fd' ?
                                                                        action = (
                                                                            <Link
                                                                                to={`/undergraduate/dashboard`}
                                                                            >
                                                                                <button
                                                                                    className="btn btn-info btn-sm"
                                                                                    onClick={() =>
                                                                                        props.setOnApplicationDetails(app)
                                                                                    }
                                                                                >
                                                                                    Continue
                                                                                </button>
                                                                            </Link>
                                                                        )
                                                                        :
                                                                        action = (
                                                                            <Link
                                                                                to={`/postgraduate/dashboard`}
                                                                            >
                                                                                <button
                                                                                    className="btn btn-info btn-sm"
                                                                                    onClick={() =>
                                                                                        props.setOnApplicationDetails(app)
                                                                                    }
                                                                                >
                                                                                    Continue
                                                                                </button>
                                                                            </Link>
                                                                        );

                                                                }
                                                            } else if (app.Status === 1) {
                                                                status = (
                                                                    <span className="badge badge-info">
                                                                        Submitted
                                                                    </span>
                                                                );
                                                            } else if (app.Status === 2) {
                                                                status = (
                                                                    <span className="badge badge-success">Approved</span>
                                                                );

                                                                action = (
                                                                    <Link
                                                                        className="btn btn-sm btn-success"
                                                                        target="_blank"
                                                                        to={`/admission-letter/${encryptData(`q=${app.EntryID}`)}`}
                                                                    >
                                                                        Print
                                                                    </Link>
                                                                );

                                                                const totalPaid = paid.reduce((acc, curr) => acc + Number(curr.AmountPaid || 0), 0);
                                                                const minAmountRequired = Number(minRegistration[0]?.MinAmountAllow || 0);

                                                                if (paid.length === 0 || totalPaid === 0) {
                                                                    // No payment made
                                                                    if (isEnrolled.length === 1) {
                                                                        enrol = (
                                                                            <a
                                                                                href="https://student.hensarduniversity.edu.ng/"
                                                                                target="_blank"
                                                                                className="btn btn-primary btn-sm"
                                                                                referrerPolicy="no-referrer"
                                                                            >
                                                                                Login
                                                                            </a>
                                                                        );
                                                                    } else {
                                                                        enrol = (
                                                                            <div>
                                                                                <a
                                                                                    href={`https://payment.hensarduniversity.edu.ng/login?user=${encryptData(app.EntryID.toString())}&email=${encryptData(app.EmailAddress)}&type=${encryptData('new')}`}
                                                                                    target="_blank"
                                                                                    className="btn btn-primary btn-sm"
                                                                                    referrerPolicy="no-referrer"
                                                                                >
                                                                                    Pay Tuition
                                                                                </a>
                                                                                <h6 className="mt-2">
                                                                                    Minimum allowed to register<br />
                                                                                    <strong>{currencyConverter(minAmountRequired)}</strong>
                                                                                </h6>
                                                                            </div>
                                                                        );
                                                                    }
                                                                } else if (totalPaid >= minAmountRequired) {
                                                                    // Minimum payment made
                                                                    enrol = (
                                                                        <Link to={`/application/enrolment`}>
                                                                            <button
                                                                                className="btn btn-info btn-sm"
                                                                                onClick={() => props.setOnApplicationDetails(app)}
                                                                            >
                                                                                Enrolment
                                                                            </button>
                                                                        </Link>
                                                                    );
                                                                } else {
                                                                    // Partial payment made
                                                                    enrol = (
                                                                        <div>
                                                                            <a
                                                                                href={`https://payment.hensarduniversity.edu.ng/login?user=${encryptData(app.EntryID.toString())}&email=${encryptData(app.EmailAddress)}&type=${encryptData('new')}`}
                                                                                target="_blank"
                                                                                className="btn btn-warning btn-sm"
                                                                                referrerPolicy="no-referrer"
                                                                            >
                                                                                Pay Remaining Tuition
                                                                            </a>
                                                                            <h6 className="mt-2">
                                                                                You have paid <strong>{currencyConverter(totalPaid)}</strong>.<br />
                                                                                Minimum to register: <strong>{currencyConverter(minAmountRequired)}</strong>
                                                                            </h6>
                                                                        </div>
                                                                    );
                                                                }
                                                            }

                                                            else if (app.Status === 4) {
                                                                status = (
                                                                    <span className="badge badge-success">
                                                                        Approved
                                                                    </span>
                                                                );
                                                                action = (
                                                                    <>
                                                                        <Link className="btn btn-sm btn-success" target={"_blank"} to={`/admission-letter/${encryptData(`q=` + app.EntryID)}`} >
                                                                            Print
                                                                        </Link>
                                                                    </>
                                                                );

                                                                if (isEnrolled.length === 1) {
                                                                    enrol = (
                                                                        <a
                                                                            href="https://student.hensarduniversity.edu.ng/"
                                                                            target="_blank"
                                                                            className="btn btn-primary btn-sm"
                                                                            referrerPolicy="no-referrer"
                                                                        >
                                                                            Login
                                                                        </a>
                                                                    );
                                                                } else {
                                                                    enrol = (
                                                                        <Link
                                                                            to={`/application/enrolment`}
                                                                        >
                                                                            <button
                                                                                className="btn btn-primary btn-sm"
                                                                                onClick={() =>
                                                                                    props.setOnApplicationDetails(app)
                                                                                }
                                                                            >
                                                                                Enrolment
                                                                            </button>
                                                                        </Link>
                                                                    );
                                                                }
                                                            } else {
                                                                status = (
                                                                    <span className="badge badge-danger">
                                                                        Rejected
                                                                    </span>
                                                                );
                                                            }
                                                            return (
                                                                <tr key={index}>
                                                                    <td>{index + 1}</td>
                                                                    <td>{app.EntryID}</td>
                                                                    <td>{app.ApplicationType === 'ug' ? 'Undergraduate' : 'Postgraduate'}</td>
                                                                    <td>{app.CourseName}</td>
                                                                    <td>
                                                                        {formatDateAndTime(
                                                                            app.InsertedDate,
                                                                            "date"
                                                                        )}
                                                                    </td>
                                                                    <td>{status}</td>
                                                                    <td>
                                                                        {action}
                                                                    </td>
                                                                    <td>{enrol}</td>
                                                                </tr>
                                                            );
                                                        })}
                                                    </tbody>
                                                </table>
                                            ) : (
                                                <div className="alert alert-info">
                                                    NO APPLICATION HISTORY FOUND
                                                </div>
                                            )}
                                        </div>
                                    </div>

                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </>
        )
    );
}
const mapStateToProps = (state) => {
    return {
        applicationLogin: state.loginDetails,
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        setOnApplicationDetails: (p) => {
            dispatch(setApplicationDetails(p));
        },
        setOnLoginDetails: (p) => {
            dispatch(setLoginDetails(p));
        },
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(StartApplication);
